document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-buy-now]');
  if (!btn) return;

  const form = btn.closest('form');
  if (!form) return;

  // ensure return_to=/checkout only for Buy Now
  const returnInput = form.querySelector('[data-buy-now-return]');
  if (returnInput) returnInput.disabled = false;

  // Mark form so we can disable return_to after submit (for safety)
  form.dataset.buyNowActive = '1';
});

document.addEventListener('submit', (e) => {
  const form = e.target.closest('form');
  if (!form) return;

  // If it's not a Buy Now flow, disable return_to so it behaves like normal add-to-cart
  if (form.dataset.buyNowActive !== '1') {
    const returnInput = form.querySelector('[data-buy-now-return]');
    if (returnInput) returnInput.disabled = true;
  } else {
    // reset for next time
    form.dataset.buyNowActive = '0';
  }
});